export const DEFAULT_EXCHANGE_DISPLAY_SETTINGS = {
    __typename: "ExchangeMealPlanDisplaySettings",
    dailyProgressViewsForMacros: "hideNumbers",
    mealProgressViewsForMacros: "hideNumbers",
    dailyProgressViewsForExchanges: "all",
    mealProgressViewsForExchanges: "all",
};
export const DEFAULT_MACRO_DISPLAY_SETTINGS = {
    __typename: "MacroMealPlanDisplaySettings",
    dailyProgressViews: "hideNumbers",
    mealProgressViews: "hideNumbers",
};
export const DEFAULT_NO_TARGETS_DISPLAY_SETTINGS = {
    dailyProgressViewsForMacros: "hideNumbers",
    mealProgressViewsForMacros: "hideNumbers",
};
export const initialExchangeMealPlanLegacyDisplaySettings = {
    __typename: "ExchangeMealPlanLegacyDisplaySettings",
    displayMealOptions: true,
    displayMealOptionMacros: true,
    displayDailyMacros: true,
    displayMealMacros: true,
    displayDailyExchanges: true,
    displayMealExchanges: true,
    displayExchangeLists: true,
};
export const initialMacroMealPlanLegacyDisplaySettings = {
    __typename: "MacroMealPlanLegacyDisplaySettings",
    displayMealOptions: true,
    displayMealOptionMacros: true,
    displayDailyMacros: true,
    displayMealMacros: true,
};
//# sourceMappingURL=utils.js.map